import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the blog module.
 * @return {*}
 */
export default function useTranslationBlog() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/blog.json'),
    'fr': import('./locales/fr/blog.json')
  }), []);

  return useModuleTranslation('blog', imports);
}
